
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCombinedShape = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 222,
  height: 222,
  viewBox: "0 0 74 74",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.36 1.463a19.801 19.801 0 0 1 26.058 25.155l-.046.122 1.76 1.76.125.134c.868 1 .826 2.516-.125 3.467l-.005.005a2.545 2.545 0 0 1-3.602.009l-2.97-2.964a2.55 2.55 0 0 1-.494-2.91 14.71 14.71 0 0 0-14.9-21.02l-.267.033 8.167 8.16c.462.494.704 1.153.673 1.83l-.016.185-1 8.054a2.565 2.565 0 0 1-2.21 2.207l-8.072 1.036a2.5 2.5 0 0 1-2.135-.72l-8.062-8.101-.035.27A14.71 14.71 0 0 0 10.2 31.004l.269.226a14.711 14.711 0 0 0 15.764 1.878 2.549 2.549 0 0 1 2.907.494l34.285 34.247 4.414-4.414-22.72-23a2.585 2.585 0 0 1 .004-3.64l.136-.122a2.57 2.57 0 0 1 3.484.159L73.35 61.75a2.504 2.504 0 0 1-.11 3.49l-7.998 7.996a2.496 2.496 0 0 1-1.81.764 2.496 2.496 0 0 1-1.804-.752L26.745 38.366l-.122.047a19.801 19.801 0 0 1-20.638-4.41l-.285-.284c-5.655-5.74-7.267-14.335-4.093-21.696l.067-.159a2.504 2.504 0 0 1 1.8-1.406c.852-.163 1.728.126 2.286.734l10.257 10.257 4.842-.597.596-4.839-10.36-10.359a2.504 2.504 0 0 1-.66-2.001l.028-.183c.163-.851.755-1.558 1.526-1.852z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"222\" height=\"222\" viewBox=\"0 0 74 74\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M12.36 1.463a19.801 19.801 0 0 1 26.058 25.155l-.046.122 1.76 1.76.125.134c.868 1 .826 2.516-.125 3.467l-.005.005a2.545 2.545 0 0 1-3.602.009l-2.97-2.964a2.55 2.55 0 0 1-.494-2.91 14.71 14.71 0 0 0-14.9-21.02l-.267.033 8.167 8.16c.462.494.704 1.153.673 1.83l-.016.185-1 8.054a2.565 2.565 0 0 1-2.21 2.207l-8.072 1.036a2.5 2.5 0 0 1-2.135-.72l-8.062-8.101-.035.27A14.71 14.71 0 0 0 10.2 31.004l.269.226a14.711 14.711 0 0 0 15.764 1.878 2.549 2.549 0 0 1 2.907.494l34.285 34.247 4.414-4.414-22.72-23a2.585 2.585 0 0 1 .004-3.64l.136-.122a2.57 2.57 0 0 1 3.484.159L73.35 61.75a2.504 2.504 0 0 1-.11 3.49l-7.998 7.996a2.496 2.496 0 0 1-1.81.764 2.496 2.496 0 0 1-1.804-.752L26.745 38.366l-.122.047a19.801 19.801 0 0 1-20.638-4.41l-.285-.284c-5.655-5.74-7.267-14.335-4.093-21.696l.067-.159a2.504 2.504 0 0 1 1.8-1.406c.852-.163 1.728.126 2.286.734l10.257 10.257 4.842-.597.596-4.839-10.36-10.359a2.504 2.504 0 0 1-.66-2.001l.028-.183c.163-.851.755-1.558 1.526-1.852z\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/combined-shape.5f5199932029b8b73b45ea93d5500ee8.svg"),
        {
          React: SvgCombinedShape,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      